import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ReverLogo } from '../../icons';
import { useTheme } from '../../theme';
import { Spinner } from '../Spinner';
import useReverLoadingStyles from './ReverLoading.Styles';
export const ReverLoading = ({ size = 'small', className, ...props }) => {
    const theme = useTheme();
    const styles = useReverLoadingStyles({
        ...{ size, ...props },
        theme
    });
    return (_jsxs("div", { className: `${styles.container} ${className}`, ...props, children: [_jsx(ReverLogo, { className: styles.logo }), _jsx(Spinner, { size: size === 'small' ? '50px' : '70px', color: "#000D1F" })] }));
};
